/* product.js — PDP interactions (loaded only on product templates, deferred).
   Variant matching + price/image/URL/ATC/sticky sync, image-swap-by-alt for property
   swatches, delivery date/time scheduler (cutoff/lead/prep/blackout), sticky ATC reveal.
   Add-on add/step is owned by cart.js (delegated). */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const API = window.TNE || {};
  const money = API.money || ((c) => c);

  const root = $('[data-product]'); if (!root) return;
  let product = null;
  try { product = JSON.parse($('[data-product-json]', root).textContent); } catch (_) {}

  /* ---------- Variant matching ---------- */
  function currentOptions() { return $$('[data-variant-option]:checked', root).map((i) => i.value); }
  function findVariant() {
    if (!product) return null;
    const opts = currentOptions();
    if (!opts.length) return product.variants.find((v) => v.available) || product.variants[0];
    return product.variants.find((v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
  }
  /* Swap the main image RELIABLY: the <img> carries a srcset, which the browser prefers over
     .src — so we must clear srcset/sizes or the picture never changes. */
  const setMainImage = (url) => { const m = $('#pdp-main-image', root); if (!m || !url) return; m.removeAttribute('srcset'); m.removeAttribute('sizes'); m.src = url; };
  function render(v) {
    const idInput = $('#variant-select', root) || $('[name="id"]', root);
    const atc = $('[data-atc]', root);
    const priceWrap = $('[data-price-wrap]', root);
    if (!v) { if (atc) { atc.disabled = true; atc.textContent = (window.theme?.strings?.unavailable) || 'Unavailable'; } return; }
    if (idInput) idInput.value = v.id;
    if (priceWrap) priceWrap.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s class="price__compare">${money(v.compare_at_price)}</s>` : '');
    $$('[data-sticky-price]').forEach((el) => (el.textContent = money(v.price)));
    if (atc) {
      atc.disabled = !v.available;
      const lbl = atc.dataset.addLabel || 'Add to cart';
      atc.textContent = v.available ? (lbl + ' · ' + money(v.price)) : (window.theme?.strings?.soldOut || 'Sold out');
    }
    if (v.featured_media) {
      const thumb = v.featured_media.id ? $(`[data-media-id="${v.featured_media.id}"]`, root) : null;
      let full = thumb && thumb.getAttribute('data-full');
      if (!full) {
        const s = v.featured_media.src || (v.featured_media.preview_image && v.featured_media.preview_image.src);
        if (s) full = s.indexOf('width=') > -1 ? s : (s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=900');
      }
      if (full) {
        setMainImage(full);
        $$('[data-thumb]', root).forEach((t) => t.removeAttribute('aria-current'));
        if (thumb) thumb.setAttribute('aria-current', 'true');
      }
    }
    if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
  }
  $$('[data-variant-option]', root).forEach((i) => i.addEventListener('change', () => render(findVariant())));

  /* ---------- Image swap by alt-text (property swatches) ---------- */
  function swapImageByAlt(name) {
    if (!name || !product) return;
    const media = product.media.find((m) => (m.alt || '').toLowerCase().includes(name.toLowerCase()));
    if (media && media.src) setMainImage(media.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2'));
  }
  $$('[data-swap-alt]', root).forEach((el) => el.addEventListener('change', () => swapImageByAlt(el.value || el.getAttribute('data-swap-alt'))));

  /* ---------- Gallery: thumbnail click + prev/next arrows + mobile swipe ---------- */
  (function () {
    const gallery = $('[data-gallery]', root); const main = $('#pdp-main-image', root);
    if (!main) return;
    const thumbs = $$('[data-thumb]', root); if (thumbs.length < 2) return;
    const idx = () => { const i = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'); return i < 0 ? 0 : i; };
    const show = (i) => {
      i = (i % thumbs.length + thumbs.length) % thumbs.length;
      const t = thumbs[i], full = t.getAttribute('data-full');
      if (full) setMainImage(full);
      thumbs.forEach((x) => x.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
      try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => show(idx() - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => show(idx() + 1));
    // Mobile swipe: horizontal drag on the main image changes the picture
    if (gallery) {
      let x0 = null, y0 = null;
      gallery.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(idx() + (dx < 0 ? 1 : -1));
        x0 = y0 = null;
      }, { passive: true });
    }
  })();

  /* ---------- Sticky ATC reveal (mobile) ---------- */
  const sticky = $('[data-sticky-atc]');
  const form = $('#product-form', root);
  if (sticky && form && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((e) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)),
      { rootMargin: '-80px 0px 0px 0px' });
    io.observe(form);
  }

  /* ---------- Delivery scheduler (client hints; capacity enforced server/app-side) ---------- */
  function initScheduler() {
    const sched = $('[data-sched]', root); if (!sched) return;
    const date = $('[data-sched-date]', sched); if (!date) return;
    const cutoff = parseInt(sched.dataset.cutoff || '', 10);
    const lead = parseInt(sched.dataset.lead || '0', 10);
    const maxDays = parseInt(sched.dataset.max || '60', 10);
    const blackoutDays = (sched.dataset.blackoutDays || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
    const blackoutDates = (sched.dataset.blackoutDates || '').split(',').map((s) => s.trim()).filter(Boolean);
    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const now = new Date();
    let minLead = lead;
    if (!isNaN(cutoff) && now.getHours() >= cutoff && lead === 0) minLead = 1;
    const min = new Date(now); min.setDate(min.getDate() + minLead);
    const max = new Date(now); max.setDate(max.getDate() + maxDays);
    const iso = (d) => d.toISOString().slice(0, 10);
    date.min = iso(min); date.max = iso(max);
    const validate = () => {
      const v = date.value; if (!v) { date.setCustomValidity(''); return; }
      const d = new Date(v + 'T00:00');
      let msg = '';
      if (blackoutDays.includes(dayNames[d.getDay()])) msg = (window.SCHED_I18N && window.SCHED_I18N.blackoutDay) || 'We don’t deliver on that day — please choose another.';
      if (blackoutDates.includes(v)) msg = (window.SCHED_I18N && window.SCHED_I18N.blackoutDate) || 'That date is unavailable — please choose another.';
      date.setCustomValidity(msg);
    };
    date.addEventListener('input', validate); validate();

    /* Time slots: when delivering TODAY (Asia/Dubai), disable each slot from 30 min before
       its start — e.g. "4:00 PM - 7:00 PM" greys out after 3:30 PM. Future dates: all enabled. */
    const timeSel = $('[data-sched-time]', sched);
    if (timeSel) {
      const pad = (n) => String(n).padStart(2, '0');
      const localIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      const dubaiNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Dubai' }));
      const startMinutes = (label) => {
        const m = String(label).match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
        if (!m) return null;
        let h = parseInt(m[1], 10); const mm = parseInt(m[2], 10); const ap = (m[3] || '').toUpperCase();
        if (ap === 'PM' && h < 12) h += 12; if (ap === 'AM' && h === 12) h = 0;
        return h * 60 + mm;
      };
      const updateSlots = () => {
        const now = dubaiNow();
        const isToday = date.value && date.value === localIso(now);
        const nowMin = now.getHours() * 60 + now.getMinutes();
        Array.from(timeSel.options).forEach((opt) => {
          if (!opt.value) return;
          let disable = false;
          if (isToday) { const s = startMinutes(opt.value); if (s !== null && nowMin >= s - 30) disable = true; }
          opt.disabled = disable;
          if (disable && opt.selected) { timeSel.value = ''; }
        });
      };
      date.addEventListener('input', updateSlots);
      date.addEventListener('change', updateSlots);
      setInterval(updateSlots, 60000);
      updateSlots();
    }
  }

  /* ---------- Gift toggle + message-card live preview ---------- */
  function initGift() {
    const toggle = $('[data-gift-toggle]', root); if (!toggle) return;
    const fields = $('[data-gift-fields]', root);
    const setMode = (gift) => {
      if (fields) {
        fields.hidden = !gift;
        fields.querySelectorAll('input, textarea, select').forEach((i) => { i.disabled = !gift; });
      }
      toggle.querySelectorAll('.choice').forEach((c) => c.classList.toggle('is-selected', c.querySelector('input')?.checked));
    };
    toggle.addEventListener('change', () => setMode(toggle.querySelector('input:checked')?.value === 'A gift'));
    setMode(false);
    // live preview: message text + selected card design
    const msg = $('[data-cardmsg]', root), prev = $('[data-card-preview]', root), pimg = $('[data-card-preview-img]', root);
    msg?.addEventListener('input', () => { if (prev) prev.textContent = msg.value; });
    $('[data-carddesign]', root)?.addEventListener('change', (e) => {
      const r = e.target.closest('input[data-card-src]');
      if (r && pimg) pimg.src = r.getAttribute('data-card-src');
      $$('[data-carddesign] .cardpick__opt', root).forEach((o) => o.classList.toggle('is-on', o.querySelector('input')?.checked));
    });
  }

  /* ---------- Quantity stepper ([data-qty] with -/+ buttons + name="quantity") ---------- */
  function initQty() {
    const q = $('[data-qty]', root); if (!q) return;
    const input = $('input[name="quantity"]', q); if (!input) return;
    const val = () => parseInt(input.value, 10) || 1;
    $('[data-qty-dec]', q)?.addEventListener('click', () => { input.value = Math.max(1, val() - 1); });
    $('[data-qty-inc]', q)?.addEventListener('click', () => { input.value = val() + 1; });
    input.addEventListener('change', () => { input.value = Math.max(1, val()); });
  }

  function init() { render(findVariant()); initScheduler(); initGift(); initQty(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---- Reviews: a real #reviews anchor above the Judge.me widget + a one-click
     "share for review" button (copies the product URL + #reviews). The widget is a
     Judge.me app block in a separate section, so we enhance it from here. The button
     label never changes; a transient status announces the copy so you can copy again. ---- */
  (function () {
    const S = {
      title: root.getAttribute('data-reviews-title') || 'Customer Reviews',
      share: root.getAttribute('data-reviews-share') || 'Share for review',
      copied: root.getAttribute('data-reviews-copied') || 'Review link copied',
      self: root.getAttribute('data-reviews-selflink') || 'Copy link to reviews'
    };
    const findWidget = () => $('.jdgm-review-widget') || $('#judgeme_product_reviews') || $('.jdgm-rev-widg') || $('[id^="judgeme"]');
    const reviewUrl = () => location.origin + location.pathname + '#reviews';
    function fallbackCopy(t) { const a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:absolute;left:-9999px'; document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(a); }
    function copy(t, cb) { if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(t).then(cb, () => { fallbackCopy(t); cb(); }); } else { fallbackCopy(t); cb(); } }
    /* Hide Judge.me's own "Customer Reviews" title so ours is the only heading. Class-based
       first (safe, doc-wide); text-match fallback scoped to the widget; observed for async render. */
    let tries = 0;
    function build() {
      if (document.getElementById('reviews')) return;
      const w = findWidget();
      if (!w) { if (tries++ < 40) setTimeout(build, 250); return; }
      const anchor = document.createElement('span'); anchor.id = 'reviews'; anchor.className = 'pdp-reviews__anchor';
      w.parentNode.insertBefore(anchor, w);
      /* Only the Share button — the widget keeps its own "Customer Reviews" heading (no duplicate). */
      const bar = document.createElement('div'); bar.className = 'pdp-reviews__share';
      const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pdp-reviews__sharebtn';
      const lbl = document.createElement('span'); lbl.textContent = S.share;
      btn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
      btn.appendChild(lbl);
      const status = document.createElement('span'); status.className = 'pdp-reviews__status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      const actions = document.createElement('div'); actions.className = 'pdp-reviews__actions'; actions.appendChild(status); actions.appendChild(btn);
      bar.appendChild(actions);
      w.parentNode.insertBefore(bar, w);
      let reset;
      btn.addEventListener('click', () => copy(reviewUrl(), () => {
        status.textContent = S.copied + ' ✓'; status.classList.add('is-show');
        clearTimeout(reset); reset = setTimeout(() => status.classList.remove('is-show'), 1800);
      }));
      if (location.hash === '#reviews') { try { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { anchor.scrollIntoView(); } }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  })();
})();
